import React, {useContext, useEffect, useState} from 'react'
import {IsPopupActiveContext} from "../PopupList";
import {Translate} from "../../translate/Translate";
import {PopupCloseCancel} from "./PopupCloseCancel";
import axios from "axios";
import {getApiLink} from "../../../functions/getApiLink";
import {PopupContext} from "../../../App";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import SimpleBar from 'simplebar-react';
import "./styles/PopupGeneratedProjectsList.scss"

interface IPopupGeneratedProjectsList {
	popup: any
	data: any
}

export const PopupGeneratedProjectsList: React.FC<IPopupGeneratedProjectsList> = ({popup, data}) => {

	const setIsPopupActive: any = useContext(IsPopupActiveContext)

	const {t} = useTranslation();

	return (

		<div className="popup-body">
			<button type="button" className="popup-close-btn" onClick={_ => setIsPopupActive(false)} title="Close">
				<svg width="15" height="15" viewBox="0 0 15 15">
					<use xlinkHref="#close"></use>
				</svg>
			</button>
			<div className="generated-projects__container popup-container" data-simplebar data-simplebar-auto-hide="false">
				<h2 className="generated-projects__title popup-title title">
					Sorry, it looks like there is no data in this period for the following:
				</h2>
				<SimpleBar className="generated-projects__inner" autoHide={false}>
					<ul className="generated-projects__list">
						{data.map((item: string, index: number) => (
							<li key={`data-item-${index}`}>{item}</li>
						))}
					</ul>
				</SimpleBar>
				<div className="generated-projects__footer">
					<button className="generated-projects__continue btn" type="button" onClick={() => setIsPopupActive(false)}>
						Continue
					</button>
				</div>
			</div>
		</div>
	)
}
